import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import Modal from "react-modal";
import { FadeLoader } from "react-spinners";
import "../../../assets/css/components/Modal/Modal.css";

const LoaderComponent = inject("sharedStore")(
  observer((props) => {
    const { sharedStore: { isShowLoader } } = props
    useEffect(() => {
      Modal.setAppElement("body");
    }, [])
    return (
      <React.Fragment>
        {isShowLoader ? (
          <Modal
            isOpen={isShowLoader}
            onRequestClose={() => console.log("")}
            className="loader-modal"
            shouldCloseOnOverlayClick={false}
          >
            <FadeLoader
              sizeUnit={"px"}
              size={200}
              color={"#fff"}
              loading={true}
            />
          </Modal>
        ) : null}
      </React.Fragment>
    );

  }))

export default LoaderComponent;



// WEBPACK FOOTER //
// ./src/components/common/Loader/Loader.jsx